import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PaginationType = {
  page: number;
  size: number;
};
export type OrderType = 'ASC' | 'DESC';

type SortParams = {
  field?: string;
  order?: OrderType;
};

type TableParamsType = {
  pagination: PaginationType;
  sort: SortParams;
};

interface BrandState {
  tableParams: TableParamsType;
}

const initialState: BrandState = {
  tableParams: {
    pagination: {
      page: 1,
      size: 10,
    },
    sort: {
      field: undefined,
      order: undefined,
    },
  },
};

export const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    setTableParams(state, action: PayloadAction<TableParamsType>) {
      state.tableParams = action.payload;
    },
  },
});

export const { setTableParams } = brandSlice.actions;
export default brandSlice.reducer;
